export default __webpack_public_path__ + "static/media/HighlightMaterialCode.e4732fd6.png";